import './AdminUsers.scss'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { UsersService } from '../../services'
import { getUsersByClientPromise } from '../../promises'
import { Button, Icon, Modal, notification, Popconfirm, Table, Tooltip, Spin, Input, DatePicker, Select } from 'antd'
import ModalCreateContent from './ModalContentCreate'
import { generatePasswordHelper } from '../../helpers'
import { ReportService } from '../../services'
import moment from 'moment'

class AdminUsers extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {},
      originalData: [],
      filteredData: [],
      isLoading: true,
      isLoadingReport: false,
      isModalVisible: false,
      modal: '',
      filters: {
        type: undefined,
        name: '',
        login: '',
        email: '',
        dateRange: null,
        status: undefined
      }
    }
  }

  async componentDidMount() {
    const data = await getUsersByClientPromise()

    await this.setState({
      data,
      originalData: data,
      filteredData: data,
      isLoading: false
    })
  }


  async handleUserDelete(userId) {
    const { t } = this.props
    await UsersService.delete(userId)
      .then(async response => {
        if (response.data.status === "OK") {
          const data = await getUsersByClientPromise()
          this.setState({ 
            data,
            originalData: data,
            filteredData: data
          })
          this.applyFilters()

          notification.success({
            message: t('messages.aml.notifications.succesfulOperation'),
            description: 'La cuenta de usuario ha sido correctamente eliminada.'
          })
        }else {
          notification.error({
            message: t('messages.aml.notifications.anErrorOcurred'),
            description: response.data.message
          })
        }
      })
      .catch(err => console.log(err))
  }

  handleModalCancel = () => {
    this.setState({ isModalVisible: false })
  }

  getTypeFilters = () => {
    const { t } = this.props
    return [
      { text: t('messages.aml.sadmin'), value: 'SADMIN' },
      { text: t('messages.aml.admin'), value: 'ADMIN' },
      { text: t('messages.aml.service'), value: 'SERVICIO' },
      { text: t('messages.aml.user'), value: 'USUARIO' },
      { text: t('messages.aml.audit'), value: 'AUDIT' }
    ]
  }

  getStatusFilters = () => {
    const { t } = this.props
    return [
      { text: t('messages.aml.active'), value: 'ACTIVE' },
      { text: t('messages.aml.inactive'), value: 'INACTIVE' }
    ]
  }

  handleFilterChange = (filterName, value) => {
    const newFilters = {
      ...this.state.filters,
      [filterName]: value
    }
    
    this.setState({ filters: newFilters }, () => {
      this.applyFilters()
    })
  }

  clearAllFilters = () => {
    const emptyFilters = {
      type: undefined,
      name: '',
      login: '',
      email: '',
      dateRange: null,
      status: undefined
    }
    
    this.setState({ filters: emptyFilters }, () => {
      this.applyFilters()
    })
  }

  applyFilters = () => {
    const { originalData, filters } = this.state
    let filtered = [...originalData]

    if (filters.type) {
      filtered = filtered.filter(record => record.type === filters.type)
    }

    if (filters.name) {
      filtered = filtered.filter(record => 
        record.name && record.name.toLowerCase().includes(filters.name.toLowerCase())
      )
    }

    if (filters.login) {
      filtered = filtered.filter(record => 
        record.login && record.login.toLowerCase().includes(filters.login.toLowerCase())
      )
    }

    if (filters.email) {
      filtered = filtered.filter(record => 
        record.email && record.email.toLowerCase().includes(filters.email.toLowerCase())
      )
    }

    if (filters.dateRange && filters.dateRange.length === 2) {
      const [startDate, endDate] = filters.dateRange
      filtered = filtered.filter(record => {
        const recordDate = moment(record.dateShortAsString, 'DD/MM/YYYY')
        if (!recordDate.isValid()) return false
        const start = moment(startDate).startOf('day')
        const end = moment(endDate).endOf('day')
        return recordDate.isSameOrAfter(start) && recordDate.isSameOrBefore(end)
      })
    }

    if (filters.status) {
      filtered = filtered.filter(record => record.status === filters.status)
    }

    this.setState({ 
      filteredData: filtered,
      data: filtered
    })
  }

  async exportHandler() {
    await this.setState({ isLoadingReport: true })
    await ReportService.read('/user/excelUsuarios', null, null, 'usuarios.xlsx')
    await this.setState({ isLoadingReport: false })
  }

  async handleModalOk(modalType, user) {
    const { currentUser, t } = this.props
    if (modalType === 'view') {
      this.setState({ isModalVisible: false })
    }

    if (modalType === 'create') {
      await UsersService.create(user)
        .then(async response => {
          if(response.data.status === 'OK') {
            const data = await getUsersByClientPromise()
            this.setState({ 
              data,
              originalData: data,
              filteredData: data,
              isModalVisible: false 
            })
            this.applyFilters()

            notification['success']({
              message: t('messages.aml.notifications.succesfulOperation'),
              description: 'Usuario creado exitosamente'
            })
          }else {
            notification.error({
              message: t('messages.aml.notifications.anErrorOcurred'),
              description: response.data.message
            })
          }
        })
        .catch(err => console.log(err))
    }

    if (modalType === 'edit') {
      await UsersService.update(user)
        .then(async response => {
          const data = await getUsersByClientPromise()
          this.setState({ 
            data,
            originalData: data,
            filteredData: data,
            isModalVisible: false 
          })
          this.applyFilters()

          notification['success']({
            message: t('messages.aml.notifications.succesfulOperation'),
            description: 'Usuario guardado'
          })
          if(currentUser.id === user.id) {
            window.location.reload()
          }
        })
        .catch(err => console.log(err))
    }
  }

  renderModal(type, user) {
    const { currentUser, t } = this.props

    let content = {}

    if (type === 'create') {
      content = {
        title: [ <Icon type="user-add" />, ' ', t('messages.aml.createNewUser') ],
        className: 'modal-user-create',
        content: <ModalCreateContent
            key={ Math.floor((Math.random() * 100) + 1) }
            currentUser={ user }
            password={ generatePasswordHelper() }
            onOk={ this.handleModalOk.bind(this) }
            onCancel={ this.handleModalCancel.bind(this) }
            modalType="create" />
      }
    }

    if (type === 'view') {
      content = {
        title: [ <Icon type="eye" />, ' ', t('messages.aml.viewUserInfo') ],
        className: 'modal-user-create',
        content: <ModalCreateContent key={ Math.floor((Math.random() * 100) + 1) } currentUser={ currentUser } user={ user } onOk={ this.handleModalOk.bind(this) } onCancel={ this.handleModalCancel.bind(this) } modalType="view" />
      }
    }

    if (type === 'edit') {
      content = {
        title: [ <Icon type="edit" />, ' ', t('messages.aml.editUserInfo') ],
        className: 'modal-user-create',
        content: <ModalCreateContent key={ Math.floor((Math.random() * 100) + 1) } user={ user }  password={ generatePasswordHelper() } currentUser={ currentUser } onOk={ this.handleModalOk.bind(this) } onCancel={ this.handleModalCancel.bind(this) } modalType="edit" />
      }
    }

    this.setState({
      isModalVisible: true,
      modal: content
    })
  }

  renderFilters = () => {
    const { t } = this.props
    const { filters } = this.state
    const { RangePicker } = DatePicker

    return (
      <div className="filters-row" style={{ 
        display: 'grid',
        gridTemplateColumns: '150px 200px 150px 220px 180px 110px 100px',
        gap: '8px',
        marginBottom: '16px',
        alignItems: 'center',
        width: '100%',
      }}>
        <Select
          style={{ width: '100%' }}
          placeholder={t('messages.aml.type')}
          value={filters.type}
          onChange={(value) => this.handleFilterChange('type', value)}
          allowClear
          size="small"
        >
          {this.getTypeFilters().map(filter => (
            <Select.Option key={filter.value} value={filter.value}>
              {filter.text}
            </Select.Option>
          ))}
        </Select>
        
        <Input
          placeholder={t('messages.aml.name')}
          value={filters.name}
          onChange={(e) => this.handleFilterChange('name', e.target.value)}
          size="small"
          style={{ width: '100%' }}
        />
        
        <Input
          placeholder={t('messages.aml.username')}
          value={filters.login}
          onChange={(e) => this.handleFilterChange('login', e.target.value)}
          size="small"
          style={{ width: '100%' }}
        />
        
        <Input
          placeholder={t('messages.aml.email')}
          value={filters.email}
          onChange={(e) => this.handleFilterChange('email', e.target.value)}
          size="small"
          style={{ width: '100%' }}
        />
        
        <RangePicker
          format="DD/MM/YYYY"
          value={filters.dateRange}
          onChange={(dates) => this.handleFilterChange('dateRange', dates)}
          style={{ width: '100%' }}
          placeholder={[t('messages.aml.creationDate'), t('messages.aml.creationDate')]}
          size="small"
        />
        
        <Select
          style={{ width: '100%' }}
          placeholder={t('messages.aml.status')}
          value={filters.status}
          onChange={(value) => this.handleFilterChange('status', value)}
          allowClear
          size="small"
        >
          {this.getStatusFilters().map(filter => (
            <Select.Option key={filter.value} value={filter.value}>
              {filter.text}
            </Select.Option>
          ))}
        </Select>
        
        <Button
          type="default"
          icon="close-circle"
          onClick={this.clearAllFilters}
          size="small"
        >
          {t('messages.aml.clear')}
        </Button>
      </div>
    )
  }

  render() {
    const { currentUser, t } = this.props

    const tableColumns = [
      { 
        title: t('messages.aml.type'), 
        dataIndex: 'type',
        width: 150,
        render: (text => {
          switch(text) {
            case 'SADMIN':
              return t('messages.aml.sadmin')
            case 'ADMIN':
              return t('messages.aml.admin')
            case 'SERVICIO':
              return t('messages.aml.service')
            case 'USUARIO':
              return t('messages.aml.user')
            case 'AUDIT':
              return t('messages.aml.audit')
            default:
              return text
          }
        })
      },
      { 
        title: t('messages.aml.name'), 
        dataIndex: 'name',
        width: 200
      },
      { 
        title: t('messages.aml.username'), 
        dataIndex: 'login',
        width: 150
      },
      { 
        title: t('messages.aml.email'), 
        dataIndex: 'email',
        width: 220
      },
      { 
        title: t('messages.aml.creationDate'), 
        dataIndex: 'dateShortAsString',
        width: 180
      },
      { 
        title: t('messages.aml.status'), 
        dataIndex: 'status',
        width: 110,
        render: (text => {
          switch(text) {
            case 'ACTIVE':
              return t('messages.aml.active')
            default:
              return t('messages.aml.inactive')
          }
        }) 
      },
      { 
        title: '', 
        dataIndex: 'id',
        width: 100,
        render: (id, user) => (
        <div className="actions">
          <Icon type="eye" theme="filled" onClick={ this.renderModal.bind(this, 'view', user) } /> &nbsp;&nbsp;
          { !(currentUser.type === 'SADMIN' || (currentUser.type === 'ADMIN' && ( user.type === 'AUDIT' || user.type === 'USUARIO' || user.type === 'SERVICIO' || currentUser.id === id ))) ?
            <Icon className="disabled" type="edit" theme="filled" />
            :
            <Icon type="edit" theme="filled" onClick={ this.renderModal.bind(this, 'edit', user) } />
          }&nbsp;&nbsp;
          {
            currentUser.type === 'AUDIT' || currentUser.id === id || user.type === 'SADMIN' ?
              <Tooltip title="No tiene permisos eliminar este usuario." placement="left" trigger="click">
                <Icon className="disabled" type="delete" theme="filled" />
              </Tooltip>
            :
              <Popconfirm
                  title={ [ 'Realmente desea eliminar ', <strong>{ user.name }</strong>, ' ?' ] }
                  placement="left"
                  onConfirm={ () => this.handleUserDelete(id) }
                  okText="Sí"
                  cancelText="No"
                >
                <Icon type="delete" theme="filled" />
              </Popconfirm>
          }
        </div>
      )}
    ]

    return (
      <div className="admin-users">
          <div className="tools-area">
          { currentUser.type !== 'AUDIT' &&
            <Button id="create-user" type="primary" icon="plus" onClick={ this.renderModal.bind(this, 'create', currentUser) }>{ t('messages.aml.createNewUser') }</Button>
          }
          &nbsp;
          <Button type="primary" icon="file-excel" onClick={ this.exportHandler.bind(this) }>{t('messages.aml.export')}</Button>
          </div>
          {this.renderFilters()}
          <div className="table-wrapper">
            {
              this.state.isLoading ?
                <Spin spinning={ true } size="large" />
              :
                <Table 
                  columns={ tableColumns } 
                  dataSource={ this.state.data } 
                  size="small" 
                  loading={ this.state.isLoadingReport }
                  pagination={{
                    showTotal: (total, range) => `${range[0]}-${range[1]} ${t('messages.aml.of')} ${total} ${t('messages.aml.entries')}`,
                    pageSize: 10,
                    showSizeChanger: false
                  }}
                />
            }
          </div>
          <div id="modal-user">
            <Modal
              title={ this.state.modal.title }
              className={ this.state.modal.className }
              visible={ this.state.isModalVisible }
              style={{ top: 30 }}
              footer={ null }
              onCancel={ this.handleModalCancel }
              >
              { this.state.modal.content }
          </Modal>
          </div>
        </div>
    )
  }
}

export default withTranslation()(AdminUsers)
